export const data = [
  [
    {
      name: 'Top UK Cities',
      subs: [],
    },
    {
      name: 'Top Lawyers',
      subs: [],
    },
    {
      name: 'Law Areas',
      subs: [],
    },
    {
      name: 'Law Firms',
      subs: [],
    },
    {
      name: 'Chambers',
      subs: [
        [
          {
            name: 'Cerulean Chambers',
            url: '',
          },
          {
            name: 'Chambers Of Ayoub Khan',
            url: '',
          },
          {
            name: 'Charles Morgan Law Ltd',
            url: '',
          },
          {
            name: 'CGSW Limited',
            url: '',
          },
          {
            name: 'CityGate Chambers Limited',
            url: '',
          },
        ],
        [
          {
            name: 'Climate Law Ltd',
            url: '',
          },
          {
            name: 'Contract Law Chambers',
            url: '',
          },
          {
            name: 'Craig Hassall Ltd',
            url: '',
          },
          {
            name: 'D Sandiford Limited',
            url: '',
          },
          {
            name: 'David Mold Limited',
            url: '',
          },
        ],
        [
          {
            name: 'DBF Law Limited',
            url: '',
          },
          {
            name: 'DBM Law Limited',
            url: '',
          },
          {
            name: 'Denise Breen-Lawton Limited',
            url: '',
          },
          {
            name: 'DL Legal Limited',
            url: '',
          },
          {
            name: 'D Hayes Public Law Practice',
            url: '',
          },
        ],
        [
          {
            name: 'Duncan Maxwell-Stewart Ltd',
            url: '',
          },
          {
            name: 'E&A Law Limited',
            url: '',
          },
          {
            name: 'EAG Legal Limited',
            url: '',
          },
          {
            name: 'Edward James Palmer Limited',
            url: '',
          },
          {
            name: 'Elderflower Solutions Limited',
            url: '',
          },
        ],
        [
          {
            name: 'Elizabeth Nicholls Ltd',
            url: '',
          },
          {
            name: 'Elysium Law Limited',
            url: '',
          },
          {
            name: 'Fiaz Siddique Limitedd',
            url: '',
          },
          {
            name: 'Five Pillars Law Limited',
            url: '',
          },
          {
            name: 'Fortis Legal Limited',
            url: '',
          },
        ],
        [
          {
            name: 'Frank Feehan KC Ltd',
            url: '',
          },
          {
            name: 'Frantz Gregory & Co Limited',
            url: '',
          },
          {
            name: 'Fredericks Shaw Ltd',
            url: '',
          },
          {
            name: 'Gaskell Law Limited',
            url: '',
          },
          {
            name: 'Geoffrey Kelly Limited',
            url: '',
          },
        ],
      ],
    },
    {
      name: 'Barristers',
      subs: [],
    },
    {
      name: 'Solicitors',
      subs: [],
    },
  ],
  [
    {
      name: 'Legal Help',
      subs: [
        [
          {
            name: 'Business & Personal',
            url: '',
          },
          {
            name: 'Find a Lawyer',
            url: '/find-a-lawyer/search',
          },
          {
            name: 'LegalDocs',
            url: '/legal-documents',
          },
          {
            name: 'Pricing',
            url: '/pricing',
          },
        ],
        [
          {
            name: 'Firms & Lawyers',
            url: '',
          },
          {
            name: 'Lawyer Portal',
            url: 'https://lawyers.legalutopia.co.uk/',
          },
          {
            name: 'Lawyer Pricing',
            url: '/pricing-lawyers',
          },
        ],
      ],
    },
    {
      name: 'Resources',
      subs: [
        [
          {
            name: 'Our app',
            url: '/ourapp',
          },
          {
            name: 'Discover Law',
            url: '/discover-law',
          },
          {
            name: 'Articles',
            url: '/articles',
          },
          {
            name: 'Podcast',
            url: '/podcasts',
          },
          {
            name: 'Law Finder',
            url: '/',
            ref: 'lawFinderRef',
            section: 'lawFinder',
          },
          {
            name: 'Complaint Assistance',
            url: '/complaint-assistance',
          },
          {
            name: 'Document Dictionary',
            url: '/',
            ref: 'documentDictionaryRef',
            section: 'documentDictionary',
          },
          {
            name: 'Legal Term Glossary',
            url: '/legal-terms-glossary',
          },
        ],
      ],
    },
    {
      name: 'Legal Utopia',
      subs: [
        [
          {
            name: 'Our Story',
            url: '/ourstory',
          },
          {
            name: 'Our Mission',
            url: '/our-mission',
          },
          {
            name: 'LawTech Around the World',
            url: '/whoweare#lawtech',
          },
          {
            name: 'Newsletter',
            url: '',
            modal: true,
          },
          {
            name: 'Contact us',
            url: '/contact-us',
          },
          {
            name: 'Terms and policies',
            url: '/terms-and-policies',
          },
        ],
      ],
    },
  ],
]
